module.exports = __webpack_public_path__ + "static/avatar-50b9c87d0449e58a93a956b4959e9889.jpg";